import getRoute from "~/utilities/configs/apiMap";
import { apiPost } from "~/services/api";
import type { UpdatedUnitResponseDTO } from "~/store/unitPage";

const POOL_SIZE = 100;

const pool = ref<UpdatedUnitResponseDTO[]>([]);
const loading = ref(false);
const fetched = ref(false);
let inflight: Promise<void> | null = null;

const doFetch = async () => {
  loading.value = true;
  try {
    const url = getRoute({ endpont: "post_units" });
    const data = await apiPost({
      url,
      body: {
        limit: POOL_SIZE,
        order: { viewsForAllTime: "desc" },
        status: ["published"],
      },
      headers: { "Cache-Control": "no-cache" },
      noCache: true,
    });
    const response = data?.data?.value as
      | { count: number | null; rows: UpdatedUnitResponseDTO[] }
      | undefined;
    pool.value = response?.rows ?? [];
    fetched.value = true;
  } catch (e) {
    console.warn("[useEstatePool] fetch failed", e);
    pool.value = [];
  } finally {
    loading.value = false;
    inflight = null;
  }
};

export function useEstatePool() {
  const ensure = () => {
    if (fetched.value) return Promise.resolve();
    if (inflight) return inflight;
    inflight = doFetch();
    return inflight;
  };
  return { pool, loading, fetched, ensure };
}
